var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'line')?_c('hr',{style:(_vm.lineStyles)}):_vm._e(),(_vm.type === 'pill')?_c('div',[_c('div',{staticClass:"line-through"},[_c('div',{staticClass:"pill shadow center-children"},[_c('span',{staticClass:"value-label"},[_vm._v(_vm._s(_vm.text))])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }